// extracted by mini-css-extract-plugin
module.exports = {"wrap":"common_wrap_208ID","fanhui":"common_fanhui_1j_1c","fullScreen":"common_fullScreen_jWDAW"};